import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Task } from 'src/app/models/Task';
import { TaskFillableField } from 'src/app/models/TaskFillableField';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-modal-fill-task-fields',
  templateUrl: './modal-fill-task-fields.page.html',
  styleUrls: ['./modal-fill-task-fields.page.scss'],
})
export class ModalFillTaskFieldsPage implements OnInit {

  @Input() task: Task;

  constructor(
    private modalCtrl: ModalController,
    private utilities: UtilitiesService,
    private storage: Storage
  ) { }

  async ngOnInit() {
    console.log(this.task);

    if (this.task) {
      let savedTask: Task = await this.storage.get('task_' + this.task.id);
      if (savedTask) {
        this.task = savedTask;
      }
    }
  }

  isInvalidValue(fillableField: TaskFillableField, ionInputId: string) {
    let ionInput: any = document.querySelector('#' + ionInputId);

    if (ionInput) {
      let value = ionInput.value;
      if (value != '') {

        value = value.replace(',', '.');
        value = parseFloat(value);

        if (fillableField.min_value != null) {
          let minValue: any = fillableField.min_value.replace(',', '.');
          minValue = parseFloat(minValue);
          if (value < minValue) {
            return true;
          }
        }

        if (fillableField.max_value != null) {
          let maxValue: any = fillableField.max_value.replace(',', '.');
          maxValue = parseFloat(maxValue);
          if (value > maxValue) {
            return true;
          }
        }
      }
    }

    return false;
  }

  saveValues() {
    this.storage.set('task_' + this.task.id, this.task);
    this.modalCtrl.dismiss({
      task: this.task
    });
  }
}
